// extracted by mini-css-extract-plugin
export default {"wrapper":"SavedFilters_wrapper__FFiTq","button":"SavedFilters_button__kAeKh"};